import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable, Subject } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root',
})
export class JiraUserService {
  constructor(private httpClient: HttpClient, private Config: Config) { }

  getAllJiraProjects(authorizationData: any) {
    let headersdata = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorizationData,
      'Access-Control-Allow-Origin': '*',
    });
    return this.httpClient
      .get(`https://dosmarttesting.atlassian.net/rest/api/2/project`, {
        headers: headersdata,
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllJiraStories(authorizationData: any, jiraProDetails: any, skip: any) {
    // console.log("jiraProDetails", jiraProDetails);
    // console.log("authorizationData", authorizationData);
    // console.log("skip", skip);
    let headersdata = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorizationData,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    });
    // `https://dosmarttesting.atlassian.net/rest/api/2/search?jql=project=dosmartQA&maxResults=50`,
    return this.httpClient
      .get(
        jiraProDetails.url +
        '/rest/api/2/search?jql=project=' +
        jiraProDetails.name +
        ' and issuetype=bug&startAt=' +
        skip +
        '&maxResults=10',
        { headers: headersdata }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAllJiraBugs(authorizationData: any, jiraProDetails: any, skip: any, filter: any) {
    // console.log("jiraProDetails", jiraProDetails);
    // console.log("authorizationData", authorizationData);
    // console.log("skip", skip);
    let headersdata = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorizationData,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    });
    // `https://dosmarttesting.atlassian.net/rest/api/2/search?jql=project=dosmartQA&maxResults=50`,
    return this.httpClient
      .get(
        jiraProDetails.url +
        '/rest/api/2/search?jql=filter=' + filter + '&project=' +
        jiraProDetails.name +
        ' and issuetype=bug&startAt=' +
        skip +
        '&maxResults=100',
        { headers: headersdata }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  
  getJiraFilters(authorizationData: any, jiraProDetails: any) {
    // console.log("jiraProDetails", jiraProDetails);
    let headersdata = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorizationData,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    });
    return this.httpClient
      .get(
        jiraProDetails.url +
        '/rest/api/2/filter/search',
        { headers: headersdata }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  jiraLogin(authorizationData: any, url: any) {
    let headersdata = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorizationData,
      'Access-Control-Allow-Origin': '*',
    });
    return this.httpClient
      .get(url + '/rest/api/2/project', { headers: headersdata })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  jiraBugCreation(authorizationData: any, url: any, bugData: any) {
    // console.log('authorizationData', authorizationData);
    // console.log('url', url);
    // console.log('bugData', bugData);
    // let headersdata = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   Accept: 'application/json',
    //   Authorization: authorizationData,
    //   // 'Content-Type': 'application/json',
    //   /*'X-Atlassian-Token': 'nocache',*/
    //   'Access-Control-Allow-Origin': '*',
    //   'Access-Control-Alow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
    //   'Access-Control-Max-Age': '3600',
    //   'Access-Control-Allow-Headers': 'x-requested-with, content-type',
    //   'User-Agent': 'firefox defaults',
    //   // // https://dosmarttesting.atlassian.net/jira/software/c/projects/TESTING/issues/?filter=allissues
    //   // 'setRequestHeader': "https://dosmarttesting.atlassian.net",
    //   // 'Access-Control-Allow-Origin': '*',
    //   // 'X-Atlassian-Token': 'nocheck'
    // });
    let body = { fields: bugData };
    // console.log('body', body);
    // return this.httpClient
    //   .post(url + '/rest/api/2/issue', body, { headers: headersdata })
    //   .pipe(
    //     map((response) => {
    //       return response;
    //     })
    //   );

    $.ajax({
      url: url + '/rest/api/2/issue',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: authorizationData,
        // 'Content-Type': 'application/json',
        /*'X-Atlassian-Token': 'nocache',*/
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Alow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
        'Access-Control-Max-Age': '3600',
        'Access-Control-Allow-Headers': 'x-requested-with, content-type',
        // 'User-Agent': 'firefox defaults',
        'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/47.0.2526.111 Safari/537.36',
      },
      type: 'POST',
      data: {
        fields: bugData
      },
      success: function (data: any) {
        return data;
      },
      error: function (request: any, error: any) {
        alert('Request: ' + JSON.stringify(request));
      },
    });
  }
}
